// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1ET-n","header":"ClearentDisclaimer_header__3GPVD","inner":"ClearentDisclaimer_inner__3AJOS"};